module.exports = __webpack_public_path__ + "img/IN.9a3a5f05.png";